import { agent } from "./agent";
import { apiKeys } from "./apiKeys";
import { authentication } from "./authentication";
import { awsMarketplace } from "./awsmarketplace";
import { chempredictor } from "./chempredictor";
import { citations } from "./citations";
import { feedbackForm } from "./feedbackForm";
import { licenses } from "./licenses";
import { listitems } from "./listitems";
import { loginPage } from "./loginPage";
import { myAccountPage } from "./myAccountPage";
import { notebooks } from "./notebooks";
import { persistent } from "./persistent/index";
import { scoreWeightNames } from "./persistent/scoreWeights";
import { pocketbook } from "./pocketbook";
import { reactions } from "./reactions";
import { searchbar } from "./searchbar";
import { user } from "./user";
import { viridischemadmin } from "./viridischemadmin";
import library from "./library";
import { chemicalInfoModalReducer as chemicalInfoModal } from "./chemicalInfoModal";

export default {
    agent,
    apiKeys,
    authentication,
    awsMarketplace,
    listitems,
    searchbar,
    user,
    loginPage,
    pocketbook,
    chempredictor,
    citations,
    feedbackForm,
    myAccountPage,
    notebooks,
    persistent,
    licenses,
    reactions,
    scoreWeightNames,
    viridischemadmin,
    library,
    chemicalInfoModal,
};
